import React from "react";
import PropTypes from "prop-types";
import {t} from "i18next";
import CardTitleCount from "pages/CardTitleCount";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  EntitySection
} from "components/Drawer";
import DrawerTitle from "components/Drawer/components/DrawerTitle/DrawerTitle";
import {EntityList} from "components/EntityList";
import {FieldNames} from "models/fields";
import css from "./EntityDrawer.module.scss";

const EntityDrawer = ({
  count,
  data,
  isOpen,
  entityType,
  entityListProps,
  footerContent,
  ...rest
}) => {
  const title = (
    <span id="entity-drawer-title">
      <CardTitleCount i18nKey={`overview.title.${entityType}`} count={count} />
    </span>
  );

  return (
    <Drawer isOpen={isOpen} {...rest} onClick={(e) => e.stopPropagation()}>
      {!isOpen ? null : (
        <>
          <DrawerHeader className={css.header} hideDivider>
            <DrawerTitle
              ariaLabel={t(`drawers.labels.common.${entityType}Count`, {count})}
              title={title}
            />
          </DrawerHeader>

          <DrawerBody>
            {/**
             * @todo When `EntityList` component is complete, replace `EntitySection`
             * with that instead
             */}
            <EntitySection
              className={css.content}
              // @todo remove this prop when `EntityList` component is complete
              collapsible={false}
              hideDivider
              entityType={entityType}
              data={data}
              count={count}
              {...{entityListProps}}
            />
          </DrawerBody>
          {footerContent && <DrawerFooter>{footerContent}</DrawerFooter>}
        </>
      )}
    </Drawer>
  );
};

EntityDrawer.propTypes = {
  /**
   * A number representing the total count of entity objects.
   */
  count: PropTypes.number,

  /**
   * An array of entity data displayed within the (opened) drawer.
   */
  data: PropTypes.array,

  /**
   * Determines if the drawer is open or closed.
   */
  isOpen: PropTypes.bool,

  /**
   * The entityType of entity the component should handle.
   */
  entityType: PropTypes.oneOf([
    FieldNames.assets,
    FieldNames.indicators,
    FieldNames.observables
  ]),

  /**
   * EntityList component props passed straight through to list
   * component to customized the view type.
   */
  entityListProps: PropTypes.shape({
    ...EntityList.propTypes
  })
};

export default EntityDrawer;
